export abstract class AbstractErrorHandler {
    public abstract handle(err: any, component?: any): void;
}
